<template>
  <naj-modal
    ref="modal"
    :title="local.caseRelatedRequest.cassationRequest.confirmationModal.title"
    :width="650"
    :footer="true"
    :persistent="true"
    @onClose="handleCancel"
  >
    <div class="cassation-confirmation-content">
      <p class="confirmation-message">
        {{ local.caseRelatedRequest.cassationRequest.confirmationModal.message }}
      </p>

      <v-simple-table class="parties-table">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-right">{{ local.caseRelatedRequest.cassationRequest.objectedPartiesTable.partyName }}</th>
              <th class="text-right">{{ local.caseRelatedRequest.cassationRequest.objectedPartiesTable.partyRole }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="party in parties"
              :key="party.casePartyId"
            >
              <td class="text-right">{{ party.name }}</td>
              <td class="text-right">{{ party.casePartyRoleName }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <div class="pledge-section">
        <v-checkbox
          v-model="pledgeAccepted"
          class="pledge-checkbox"
          :label="local.caseRelatedRequest.cassationRequest.confirmationModal.pledge"
          hide-details
        ></v-checkbox>
      </div>
    </div>

    <template
      slot="actions"
      slot-scope="{ closeNajModal }"
    >
      <div class="modal-actions">
        <naj-button
          :disabled="!pledgeAccepted"
          :loading="actionLoading"
          @click="handleConfirm"
        >
          {{ local.caseRelatedRequest.cassationRequest.confirmationModal.confirm }}
        </naj-button>
        <naj-button
          outlined
          @click="handleCancel"
        >
          {{ local.caseRelatedRequest.cassationRequest.confirmationModal.cancel }}
        </naj-button>
      </div>
    </template>
  </naj-modal>
</template>

<script>
export default {
  name: 'CassationSendConfirmationModal',
  props: {
    modalVisibility: {
      type: Boolean,
      default: false,
    },
    parties: {
      type: Array,
      default: () => [],
    },
    actionLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pledgeAccepted: false,
    };
  },
  watch: {
    modalVisibility(newValue) {
      if (newValue) {
        this.pledgeAccepted = false;
        this.$refs.modal.show();
      } else {
        this.$refs.modal.close();
      }
    },
  },
  methods: {
    handleConfirm() {
      if (this.pledgeAccepted) {
        this.$emit('confirm');
      }
    },
    handleCancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss" scoped>
.cassation-confirmation-content {
  padding: 8px 0;
}

.confirmation-message {
  font-size: 15px;
  color: #333;
  margin-bottom: 16px;
  line-height: 1.8;
}

.parties-table {
  margin-bottom: 20px;

  thead th {
    background-color: #f5f5f5 !important;
    font-weight: bold;
    font-size: 14px !important;
    color: #333 !important;
    border-bottom: 2px solid #e0e0e0 !important;
  }

  tbody td {
    padding: 12px 16px !important;
    border-bottom: 1px solid #eee !important;
  }
}

.pledge-section {
  margin-top: 16px;
  padding: 12px 0;
  border-top: 1px solid #eee;
}

.pledge-checkbox {
  margin-top: 0;

  ::v-deep .v-label {
    font-size: 14px;
    color: #333;
  }
}

.modal-actions {
  display: flex;
  gap: 12px;
}
</style>
